import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/content-styles.css';
import AppRouter from './AppRouter';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProtectedRoute>
        <AppRouter />
      </ProtectedRoute>
    </AuthProvider>
  </React.StrictMode>
);
